import React, {useEffect, useRef} from 'react';
import {Animated, View} from 'react-native';
import {
  groupBg,
  groupBorderColor,
  groupRadius,
  textInputBg
} from '../../../style/adminTools';

const ShimmerRows = ({
  count = 8,
  rowHeight = 50,
  gap = 6,
  rowRadius = 6,
  testID
}) => {
  const pulse = useRef(new Animated.Value(0.45)).current;

  useEffect(() => {
    const loop = Animated.loop(
      Animated.sequence([
        Animated.timing(pulse, {
          toValue: 1,
          duration: 800,
          useNativeDriver: false
        }),
        Animated.timing(pulse, {
          toValue: 0.45,
          duration: 800,
          useNativeDriver: false
        })
      ])
    );
    loop.start();
    return () => loop.stop();
  }, [pulse]);

  return (
    <View
      testID={testID}
      style={{
        padding: 12,
        backgroundColor: groupBg,
        borderWidth: 1,
        borderColor: groupBorderColor,
        borderRadius: groupRadius
      }}
    >
      {Array.from({length: count}, (_, index) => (
        <Animated.View
          key={index}
          testID={testID ? `${testID}Row` : undefined}
          style={{
            height: rowHeight,
            marginBottom: index === count - 1 ? 0 : gap,
            borderRadius: rowRadius,
            backgroundColor: textInputBg,
            opacity: pulse
          }}
        />
      ))}
    </View>
  );
};

export default ShimmerRows;
